import { DtProduct } from '@ow/ditto-core'

const { transformer } = DtProduct

export { default as Render } from './render'
export { default as Filter } from './filter'
export { transformer }
